import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddAPhotoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_a_photo"}/>
}
